import { render } from "./SongCreateView.vue?vue&type=template&id=0844f22d&scoped=true"
import script from "./SongCreateView.vue?vue&type=script&lang=js"
export * from "./SongCreateView.vue?vue&type=script&lang=js"

import "./SongCreateView.vue?vue&type=style&index=0&id=0844f22d&scoped=true&lang=css"

import exportComponent from "/Users/vaninamikova/Documents/Learning/Old Projects/tab-tracker/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0844f22d"]])

export default __exports__